// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"86afef08","568":"e7e91e3e"}[chunkId] + ".chunk.css";
};